// @flow

import React from 'react'

import NotificationCounts from '@/views/notification-counts'
import PortfolioSelect from '@/controls/portfolio-select'
import Preferences from '@/views/preferences'
// import Usage from '@/views/usage'

type Props = {
  children?: any,
}

export const RawBasicPage = ({children}: Props) =>
  <div>
    <div className="row">
      <div className="col-xs-9">
        <NotificationCounts />
      </div>
      <div className="col-xs-3">
        <div className="row">
          <div className="col-xs-12">
            <PortfolioSelect />
          </div>
          <div className="col-xs-12">
            <Preferences />
            {/* Commenting out the below component temporarily
            <Usage /> */}
          </div>
        </div>
      </div>
    </div>
    {children}
    <div className='footer'></div>
  </div>

export default RawBasicPage



// WEBPACK FOOTER //
// ./src/views/basic-page/index.js